/* global  */ // tUrl等のグローバル変数を宣言する
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

function slideAnime() {
  //====左に動くアニメーションここから===
  $('.leftAnime').each(function () {
    var elemPos = $(this).offset().top - 50
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll >= elemPos - windowHeight) {
      //左から右へ表示するクラスを付与
      //テキスト要素を挟む親要素（左側）とテキスト要素を元位置でアニメーションをおこなう
      $(this).addClass('slideAnimeLeftRight') //要素を左枠外にへ移動しCSSアニメーションで左から元の位置に移動
      $(this).children('.leftAnimeInner').addClass('slideAnimeRightLeft') //子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
      if ($(this).hasClass('slow')) {
        $(this).addClass('slow') //要素を左枠外にへ移動しCSSアニメーションで左から元の位置に移動
        $(this).children('.leftAnimeInner').addClass('slow') //子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
      }
    } else {
      //左から右へ表示するクラスを取り除く
      $(this).removeClass('slideAnimeLeftRight')
      $(this).children('.leftAnimeInner').removeClass('slideAnimeRightLeft')
    }
  })
}

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  slideAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面が読み込まれたらすぐに動かしたい場合の記述

/*
 ######   ###### ########   #######  ##        ##
##       ##      ##     ## ##     ## ##        ##
 ######  ##      ########  ##     ## ##        ##
      ## ##      ##   ##   ##     ## ##        ##
 ######   ###### ##     ##  #######  ########  ########
*/
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  slideAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面をスクロールをしたら動かしたい場合の記述

$(function () {
  $(window).scroll(function () {
    let scroll = $(window).scrollTop()
    if (scroll > 0) {
      $('.header').addClass('shadow')
    } else {
      $('.header').removeClass('shadow')
    }
    // if (scroll >= 350) {
    //   $('.op-box').addClass('show')
    // } else {
    //   $('.op-box').removeClass('show')
    // }
  })
})

/*
########  #######   #######  ######## ######## ########
##       ##     ## ##     ##    ##    ##       ##     ##
######   ##     ## ##     ##    ##    ######   ########
##       ##     ## ##     ##    ##    ##       ##   ##
##        #######   #######     ##    ######## ##     ##
*/
$(function () {
  // $('.footerLink__sp-wrap').hide()
  $('.js-sp-footer-menu').hide()
  $('.js-footer-open').click(function () {
    $(this).parent().next('.js-sp-footer-menu').slideToggle()
    $(this).toggleClass('open')
    return false
  })

  // $('.gNavBtn__box').click(function () {
  //   if ($('.md-overlay').hasClass('active')) {
  //     $('.header__left').hide()
  //     $('.headerNav__btn').hide()
  //   } else {
  //     $('.header__left').show()
  //     $('.headerNav__btn').show()
  //   }
  // })

  $('.acc-btn').click(function () {
    $(this).toggleClass('open')
  })
})

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

/*
   ###    ##    ## #### ##     ## ########
 ##   ##  ####  ##  ##  #### #### ##
##     ## ## ## ##  ##  ## ### ## ######
######### ##  ####  ##  ##     ## ##
##     ## ##    ## #### ##     ## ########
*/
// 動きのきっかけの起点となるアニメーションの名前を定義
function BgFadeAnime() {
  // 背景色が伸びて出現（左から右）
  $('.bgLRextendTrigger').each(function () {
    //bgLRextendTriggerというクラス名が
    var elemPos = $(this).offset().top - 50 //要素より、50px上の
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass('bgLRextend') // 画面内に入ったらbgLRextendというクラス名を追記
    } else {
      $(this).removeClass('bgLRextend') // 画面外に出たらbgLRextendというクラス名を外す
    }
  })

  // 文字列を囲う子要素
  $('.bgappearTrigger').each(function () {
    //bgappearTriggerというクラス名が
    var elemPos = $(this).offset().top - 50 //要素より、50px上の
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass('bgappear') // 画面内に入ったらbgappearというクラス名を追記
    } else {
      $(this).removeClass('bgappear') // 画面外に出たらbgappearというクラス名を外す
    }
  })
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  BgFadeAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  BgFadeAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面が読み込まれたらすぐに動かしたい場合の記述

$(function () {
  // $('.gNavBtn__box').click(function () {
  //   if ($('.md-overlay').hasClass('active')) {
  //     $('.header__left').hide()
  //     $('.headerNav__btn').hide()
  //   } else {
  //     $('.header__left').show()
  //     $('.headerNav__btn').show()
  //   }
  // })

  $('.acc-btn').click(function () {
    $(this).toggleClass('open')
  })
})

/*
   ###     ######   ######
 ##   ##  ##       ##
##     ## ##       ##
######### ##       ##
##     ##  ######   ######
*/
$('.js-acc').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

if (window.matchMedia('(max-width:768px)').matches) {
  if ($('.js-acc-sp')[0]) {
    $('.js-acc-sp').next().hide()
    $('.js-acc-sp').on('click', function () {
      $(this).toggleClass('open')
      $(this).next('.js-faq-answer').slideToggle()
      return false
    })
  }
  if ($('.js-gnav')[0]) {
    $('.js-gnav-item').hide()
    $('.js-gnav-open').on('click', function () {
      $(this).toggleClass('open')
      $(this).parent().next('.js-gnav-item').slideToggle()
    })
  }
}

/*
#### ##    ## ######## ######## ########  ##     ## #### ######## ##      ##
 ##  ####  ##    ##    ##       ##     ## ##     ##  ##  ##       ##  ##  ##
 ##  ## ## ##    ##    ######   ########  ##     ##  ##  ######   ##  ##  ##
 ##  ##  ####    ##    ##       ##   ##    ##   ##   ##  ##       ##  ##  ##
#### ##    ##    ##    ######## ##     ##    ###    #### ########  ###  ###
*/
const interviewCategories = ['occupation', 'interviewCat', 'sex', 'age', 'place', 'theme']
// 検索ボタン押下時
$('.js-interviewSearch').on('click', function () {
  let query = ''
  $.each(interviewCategories, function (idx, category) {
    // チェックボックス取得
    let arrCategory = $('.js-interviewSearch-item input[name="' + category + '"]:checked')
      .map(function () {
        return $(this).attr('val')
      })
      .get()

    // URLパラメータ生成
    if (arrCategory.length) {
      if (query !== '') {
        query += '&'
      }
      query += category + '='
      $.each(arrCategory, function (index, value) {
        query += value + ','
      })
      query = query.slice(0, -1)
    }
  })
  const link_url = $(this).attr('href')
  if (query !== '') {
    $(this).attr('href', link_url + '?' + query)
  }
})

// チェックボックス表示
if ($('.js-interviewSearch')[0] && location.search !== '') {
  $.each(interviewCategories, function (i, category) {
    if (getParam(category)) {
      let arrVal = getParam(category).split(',')
      $.each(arrVal, function (j, val) {
        if (val === 'interviewCat') {
          val = 'cat'
        }
        $('input[val="' + val + '"').prop('checked', true)
      })
    }
  })
}
// URLからパラメータ取得
function getParam(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) {
    return null
  }
  if (!results[2]) {
    return ''
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

// インタビュー詳細スライダー化
var interviewOtherSlide = new Swiper('#interviewOtherSlide', {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 40,
  centeredSlides: true,
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
      centeredSlides: false,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

$(function () {
  $(window).scroll(function () {
    var scroll = $(this).scrollTop()
    if (scroll > 110) {
      $('.js-op-box').addClass('show')
    } else {
      $('.js-op-box').removeClass('show')
    }
  })
})

window.addEventListener('DOMContentLoaded', function () {
  $('.topMv__slide--1').children('ul').addClass('slideshow')
  $('.topMv__slide--2').children('ul').addClass('slideshow--reverse')
  $('.topMv__slide--3').children('ul').addClass('slideshow')
})

$(function () {
  $(window).scroll(function () {
    let scroll = $(window).scrollTop()
    if (scroll > 0) {
      $('.js-hover').addClass('is-scrolled')
    } else {
      $('.js-hover').removeClass('is-scrolled')
    }
  })
})
